
import {
  getNewProjectList,
  getProjectDetail,
  delProject,
  deleteProjectGroup,
} from "@/api/enterprise";
import projectEditDraw from "./project-draw-editor";
import projectStyle from "./project-style";
import projectNewGroup from "./project-new-group";
import projectItemEdit from "./project-item-edit";
import projectDownFile from "./project-down-file";
export default {
  props: ["building"],
  watch: {},
  components: {
    projectStyle,
    projectNewGroup,
    projectDownFile,
  },
  data() {
    return {
      keyword: "",
      activeId: "",
      checkList: [],
      isNext: true,
      layerLoading: false,
      showIndoor: false,
      list: [],
    };
  },
  destroyed() {
    this.$layer.closeAll();
  },
  mounted() {
    this.getGroupOptions();
  },
  methods: {
    async exportFileDXT(data) {
      this.$layer.iframe({
        content: {
          content: projectDownFile, //传递的组件对象
          parent: this, //当前的vue对象
          data: {
            project_id: data.project_id,
            fileName: data.project_name,
          }, //props
        },
        maxmin: false,
        time: 0,
        shadeClose: false,
        resize: false,
        scrollbar: false,
        area: ["300px", "200px"],
        title: "选择坐标系",
        cancel: function () {},
      });
    },
    fetch() {
      this.getGroupOptions();
    },
    createGroup() {
      this.$layer.iframe({
        content: {
          content: projectNewGroup, //传递的组件对象
          parent: this, //当前的vue对象
          data: {
            info: {},
          }, //props
        },
        maxmin: false,
        time: 0,
        shadeClose: false,
        resize: false,
        scrollbar: false,
        area: ["300px", "200px"],
        title: "新建分组",
        cancel: function () {},
      });
    },
    async filter() {
      await this.getGroupOptions();
      if (this.keyword) {
        this.list = this.list.map((item) => {
          item.projects = item.projects.filter(
            (data) => data.project_name.indexOf(this.keyword) > -1
          );
          return item;
        });
      }
    },
    chooseActiveToEdit(id) {
      if (
        $(`#checked_${id}`).find(".is-checked").length > 0 &&
        $(`#edit_${id}`).hasClass("active")
      ) {
        $(`#projectStyleComp_${id}`).toggleClass("active");
        $(`#edit_${id}`).toggleClass("active");
        return false;
      }
      if ($(`#checked_${id}`).find(".is-checked").length == 0) {
        $(`#checked_${id}`).click();
      } else {
        $(`#checked_${id}`).click();
        $(`#checked_${id}`).click();
      }

      $(`.edit-box:not("#edit_${id}")`).removeClass("active");
      $(`#edit_${id}`).toggleClass("active");
      $(`.project_style:not("#projectStyleComp_${id}")`).removeClass("active");

      $(`#projectStyleComp_${id}`).toggleClass("active");
    },
    async handleCheckAllChange(e, project_id) {
      if (e) {
        $(".vlayer.lv-icon-mini").click();
        const res = await getProjectDetail({ project_id });

        if ($(`#projectStyleComp_${project_id}`).hasClass("active")) {
          this.$refs[`projectStyleComp_${project_id}`][0].setStyle(
            res.data.style
          );

          res.data.files &&
            this.$refs[`projectStyleComp_${project_id}`][0].setFiles(
              res.data.files
            );

          res.data.attribute &&
            this.$refs[`projectStyleComp_${project_id}`][0].setAttribute(
              res.data.attribute
            );
        }

        let layerId = this.$layer.iframe({
          content: {
            content: projectEditDraw, //传递的组件对象
            parent: this, //当前的vue对象
            data: {
              // building: this.building,
              info: res.data,
            }, //props
          },
          maxmin: true,
          shade: false,
          time: 0,
          skin: "custom-layer-class-add",
          shadeClose: false,
          resize: false,
          scrollbar: false,
          offset: ["300px"],
          area: ["650px", "330px"],
          title: `${res.data.project_name}`,
          cancel: function () {},
        });
        this.checkList.push({
          layerId,
          project_id,
        });
        $(".vl-notify-main").addClass("custom-layer-class-add");
      } else {
        const iet = this.checkList.find(
          (item) => item.project_id == project_id
        );
        const idx = this.checkList.findIndex(
          (item) => item.project_id == project_id
        );

        if (iet.layerId) {
          this.$layer.close(iet.layerId);
        }
        this.checkList.splice(idx, 1);

        if ($(`#edit_${project_id}`).hasClass("active")) {
          $(this.$refs[`projectStyleComp_${project_id}`][0].$el).removeClass(
            "active"
          );
          $(`#edit_${project_id}`).removeClass("active");
        }
      }
    },
    del(item) {
      this.$confirm(`您确定删除吗?删除后项目将消失，不可找回！`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 确定操作
          const res = await delProject({ project_id: item.project_id });
          if (res.code == 0) {
            this.$toasted.success("操作成功!", {
              position: "top-center",
              duration: 2000,
            });
            this.fetch();
          }
        })
        .catch(() => {});
    },

    editGroup(da) {
      this.$layer.iframe({
        content: {
          content: projectNewGroup, //传递的组件对象
          parent: this, //当前的vue对象
          data: {
            info: da,
          }, //props
        },
        maxmin: false,
        time: 0,
        shadeClose: false,
        resize: false,
        scrollbar: false,
        area: ["300px", "200px"],
        title: "修改分组名",
        cancel: function () {},
      });
    },
    delGroup(da) {
      this.$confirm(
        `您确定删除吗?删除后该分组的所有的项目将消失，不可找回！`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          // 确定操作
          const res = await deleteProjectGroup({ group_id: da.group_id });
          if (res.code == 0) {
            this.$toasted.success("操作成功!", {
              position: "top-center",
              duration: 2000,
            });
            this.fetch();
          }
        })
        .catch(() => {});
    },

    async editNewOne(item) {
      this.$layer.iframe({
        content: {
          content: projectItemEdit, //传递的组件对象
          parent: this, //当前的vue对象
          data: {
            info: item,
            isEdit: true,
            isMove: false,
          }, //props
        },
        maxmin: false,
        time: 0,
        shadeClose: false,
        resize: false,
        scrollbar: false,
        area: ["400px", "250px"],
        title: "重命名",
        cancel: function () {},
      });
    },

    async move(item) {
      // const res = await getProjectDetail({project_id: item.project_id})
      // if (Array.isArray(res.data.estimate_data)) {
      //     res.data.estimate_data = {}
      // }
      // item.estimate_data = res.data.estimate_data
      this.$layer.iframe({
        content: {
          content: projectItemEdit, //传递的组件对象
          parent: this, //当前的vue对象
          data: {
            info: item,
            isEdit: false,
            isMove: true,
          }, //props
        },
        maxmin: false,
        time: 0,
        shadeClose: false,
        resize: false,
        scrollbar: false,
        area: ["400px", "250px"],
        title: "移动分组",
        cancel: function () {},
      });
    },
    async getGroupOptions() {
      const res = await getNewProjectList();
      this.list = res.data;
    },
    addProj() {
      this.$layer.closeAll();
      let draw = window.widget.plotManager.draw.mapboxDraw;
      draw.deleteAll();
      this.$emit("addProj");
    },
    showPop() {
      this.showIndoor = true;
    },
    hidePop() {
      this.$emit("hidePop");
    },
  },
};
